export const polaznikTabsData = [
  { value: "one", label: "Aktivni programi" },
  { value: "two", label: "Završeni programi" },
];
